import {Component, OnInit, ViewChild} from '@angular/core';
import {CalendarOptions, FullCalendarComponent} from '@fullcalendar/angular';
import {EventManagerService} from "../../services/event-manager.service";
import {UiManagerService} from "../../services/ui-manager.service";
import {Utils} from "../../utils";
import {DatesSetArg} from "@fullcalendar/common";
import {ActivatedRoute, Router} from "@angular/router";
import {EventType} from "../../models/calendar-event";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {SettingsManagerService} from "../../services/settings-manager.service";

enum CalendarView {
  MONTH = 'dayGridMonth',
  WEEK = 'dayGridWeek'
}

@Component({
  selector: 'app-calendar-page',
  templateUrl: './calendar-page.component.html',
  styleUrls: ['./calendar-page.component.scss']
})
export class CalendarPageComponent implements OnInit {

  @ViewChild(FullCalendarComponent)
  calendar: FullCalendarComponent;

  isLoading = true;

  calendarOptions: CalendarOptions = {
    initialView: CalendarView.MONTH,
    locale: this.settingsManagerService.getLanguage(),
    firstDay: 1,
    buttonText: {
      today: this.translatePipe.transform('Today')
    },
    dayHeaderFormat: { weekday: 'long' },
    dayHeaderClassNames: 'weekday',
    events: null,
    dateClick: this.addEventFromDay.bind(this),
    displayEventEnd: true,
    eventClick: this.editEvent.bind(this),
    datesSet: this.onDateChanged.bind(this),
  };

  startDate: Date;
  endDate: Date;

  constructor(
    private eventManagerService: EventManagerService,
    private uiManagerService: UiManagerService,
    private route: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    private translatePipe: TranslatePipe,
    private settingsManagerService: SettingsManagerService,
  ) { }

  ngOnInit(): void { }

  async fetchEvents() {
    this.isLoading = true;
    this.calendarOptions.events = await this.eventManagerService.getEventsToDisplay(this.startDate, this.endDate);
    this.isLoading = false;
  }

  onDateChanged(args: DatesSetArg) {
    this.startDate = args.start;
    this.endDate = args.end;
    this.fetchEvents();
  }

  addEventFromDay(day: any) {
    if (day.date >= Utils.today) {
      this.addEvent(day.date, EventType.PLANNED_MAINTENANCE);
    } else {
      this.uiManagerService.notify(this.translatePipe.transform('You cannot create an event in the past'));
    }
  }

  addEvent(date?: Date, eventType?: EventType) {
    date = date || new Date();
    this.router.navigate(['event', 'create'], {
      queryParams: { startDate: date.getTime(), eventType },
      relativeTo: this.route
    });
  }

  editEvent(calendarEvent) {
    this.router.navigate(['event', calendarEvent.event.id], { relativeTo: this.route });
  }

  switchView() {
    switch (this.calendar.getApi().view.type) {
      case CalendarView.MONTH:
        this.calendar.getApi().changeView(CalendarView.WEEK);
        this.calendarOptions.initialView = CalendarView.WEEK;
        break;
      case CalendarView.WEEK:
        this.calendar.getApi().changeView(CalendarView.MONTH);
        this.calendarOptions.initialView = CalendarView.MONTH;
        break;
    }
  }

  get CalendarView() { return CalendarView; }

  get EventType() { return EventType; }

}
